import config from '../../config'
import { HTTP } from  '../../http'
const pageSize = 15
const data = [{days: 1}, {days: 15}, {days: 30}]
export default {
    findAll: (keywords, page) => {
        return new Promise((resolve, reject) => {
            const model = {
                "searchOptions": {
                    "pageIndex": page,
                    "pageSize": pageSize,
                    "keywords": keywords
                }
            }
            HTTP.post(config.apiEndpoints.payoutIntervalUri.concat('find'), model).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    all: () => {
        return new Promise((resolve, reject) => {
            resolve({data: data})
            // HTTP.get(config.apiEndpoints.payoutIntervalUri).then((response)=>{
            //     resolve(response)
            // }, (error)=>{
            //     reject(error)
            // })
        })
    },
    find: (id) =>{
        return new Promise((resolve, reject) => {
            HTTP.get(config.apiEndpoints.payoutIntervalUri.concat(id)).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    create: (model) => {
        return new Promise((resolve, reject) => {
            HTTP.post(config.apiEndpoints.payoutIntervalUri, {entity: model}).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    update: (model) => {
        return new Promise((resolve, reject) => {
            HTTP.put(config.apiEndpoints.payoutIntervalUri, {entity: model}).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    }
}